import recoverGeneral from '@/store/modules/recover/general';

export default {
  recoverGeneral,
};
